import React, { useEffect, useState } from 'react'
import {
  Input,
  Form,
  FormGroup,
  ControlLabel,
  Grid,
  Row,
  Col,
  RadioGroup,
  Radio,
  SelectPicker,
  InputGroup,
  Uploader,
  Icon,
  Message,
  DatePicker,
  IconButton,
  ButtonGroup,
  Whisper,
  Button,
  Tooltip,
} from 'rsuite'
import { isEmpty } from 'lodash-es'
import moment from 'moment'
import classNames from 'classnames'
import ErrorMessage from '../../../components/message/errorMessage/ErrorMessage'
import {
  isValidators,
  isRequired,
  getMaxLengthData,
  requiredFiled,
  isImageOrPdf,
} from '../../../utils/ValidatorUtils'
import AppContext from '../../../context/AppContext'
import { verificationPerson, verificationThaiDPerson } from '../../../redux/actions/verification'
import { DATE_FORMAT, LOCAL_DAY_TH } from '../../../constants/date'
import './styles.less'
import notification from '../../../utils/notification'
import { DEFAULT_ERR_MSG } from '../../../constants/msgText'
import { doneLoading, startLoading } from '../../../utils/loading'
import InformationIncon from '../../help/InformationIncon'

export default function PersonalBasicInfoForm({
  honorificOptions,
  schema: _schema,
  register,
  errors,
  Controller,
  control,
  getValues,
  setValue,
  clearErrors,
  handleFile,
  fileErr,
  setFileErr,
  isSubProject,
  projectId,
  type,
  offerFundedInfoSchema
}) {
  const { theme } = React.useContext(AppContext)

  const [schema, setSchema] = useState(_schema)
  const [showOtherNationality, setShowOtherNationality] = useState(schema.nationality?.value === 2)

  const [isLoadingVerification, setIsLoadingVerification] = useState(false)

  const [subMission, setSubMission] = useState(schema?.submission?.value || 0)
  const [idCardFileError, setIdCardFileError] = useState(false)
  const [powerOfAttorneyFileError, setPowerOfAttorneyFileError] = useState(false)
  const [isDeleteIdCard, setIsDeleteIdCard] = useState(false)
  const [isDeletePowerOfAttorney, setIsDeletePowerOfAttorney] = useState(false)
  const [isVerification, setIsVerification] = useState(true)
  const [isThaiDVerifing, setIsThaiDVerifing] = useState(false)
  const [isLoadThaiDVerifing, setIsLoadThaiDVerifing] = useState(false)
  
  const [offerFundedInfo, setOfferFundedInfo] = useState(offerFundedInfoSchema?.docList || [])
  const [granteeType, setGranteeType] = useState(1)
  const [subType, setSubType] = useState(schema.personType?.optionSelected)

  const onClickVerificationPerson = async () => {
    const idNumber = getValues(schema.idNumber.name)
    if (!idNumber) {
      return
    }
    setIsLoadingVerification(true)
    let personData
    try {
      personData = await verificationPerson(idNumber)
    } catch (e) {}
    setIsLoadingVerification(false)
    if (personData) {
      setValueVerification(personData)
    }
    setIsVerification(true)
  }

  const onThaiDVerified = async () => {
    setIsLoadThaiDVerifing(true)
    startLoading()

    try {
      const email = getValues(schema.email.name)
      const firstName = getValues(schema.firstName.name)
      const lastName = getValues(schema.lastName.name)
      const owner = type == 'grantee' && subMission == 1

      if (!owner && isEmpty(email)) {
        notification.open('error', {
          title: `${type == 'grantee' ? 'กรณียื่นแทน' : ''} กรุณาระบุอีเมล์ด้วย`,
          duration: 5000,
        })
      } else if (!owner && (isEmpty(firstName) || isEmpty(lastName))) {
        notification.open('error', {
          title: `${type == 'grantee' ? 'กรณียื่นแทน' : ''} กรุณาระบุชื่อ-นามสกุลด้วย`,
          duration: 5000,
        })
      } else {
        var request = {
          //ProjectCode: '',
          projectId: projectId,
          type: type,
          email: email,
          name: firstName + ' ' + lastName,
          owner: owner,
        }

        let result = await verificationThaiDPerson(request)
        if (result?.success) {
          if (!isEmpty(result.url)) {
            setIsLoadThaiDVerifing(false)
            doneLoading()
            window.open(result.url, '_self')
          } else {
            notification.open('success', {
              title: 'แจ้งผล',
              description: (
                <div style={{ textAlign: 'left' }}>{result.message || 'ดำเนินการสำเร็จ'} </div>
              ),
              duration: 5000,
            })
          }
        } else {
          notification.open('error', {
            title: result?.message || DEFAULT_ERR_MSG,
            duration: 5000,
          })
        }
      }
    } catch (e) {
      console.log(e)
      notification.open('error', {
        title: e?.response?.data?.errors?.message || DEFAULT_ERR_MSG,
        duration: 5000,
      })
    }

    setIsLoadThaiDVerifing(false)
    doneLoading()
  }

  const setValueVerification = (value) => {
    if (value) {
      setValue('id', value.personId)
      setValue(schema.idNumber.name, value.idcard)
      setValue(schema.honorific.name, value.masterPreNameId)
      setValue(schema.firstName.name, value.firstName)
      setValue(schema.lastName.name, value.lastName)
      setValue(schema.nationality.name, value.nationality)
      setValue('nationalityInputOther', value.nationalityOther)
      setValue(schema.mobile.name, value.mobileNumber)
      setValue(schema.telephone.name, value.telephoneNumber)
      setValue(schema.fax.name, value.fax)
      setValue(schema.email.name, value.email)
      setValue(schema.dateOfBirth.name, value.dateOfBirth)
      setValue(schema.lineId.name, value.lineId)
      setValue('powerOfAttorney', value.powerOfAttorneyFilePath || undefined)
      setValue('idCard', value.idCard || undefined)
      setValue(schema.personType.name, null)

      setSubType()
      clearErrors()
    }
  }

  const clearInput = () => {
    setValue('id', '')
    setValue(schema.idNumber.name, '')
    setValue(schema.honorific.name, '')
    setValue(schema.firstName.name, '')
    setValue(schema.lastName.name, '')
    setValue(schema.nationality.name, '')
    setValue('nationalityInputOther')
    setValue(schema.mobile.name, '')
    setValue(schema.telephone.name, '')
    setValue(schema.fax.name, '')
    setValue(schema.email.name, '')
    setValue(schema.dateOfBirth.name, '')
    setValue(schema.lineId.name, '')
    setValue('powerOfAttorney', '')
    setValue('idCard', '')
    setValue(schema.personType.name, '')
    setSubType()
    clearErrors()
  }
  
  const renderOfferFundedInfo = (granteeType, subType) => {
    var data = []
    offerFundedInfo?.forEach(element => {
      if(element.type == granteeType){
        element?.subTypeList?.forEach(item => {
          if(item.subType == subType){
            data = item.list
          }
        })
      }
    });
    return data || []
  }

  return (
    <>
      <Grid fluid>
        <Form fluid className="personal-basic-info-form">
          <FormGroup>
            {schema.thaiDVerified && (
              <Message
                showIcon={false}
                type={'success'}
                description={
                  <>
                    <Icon size="3x" style={{ color: '#2da888' }} icon={'check-circle-o'}></Icon>
                    <span style={{ color: '#2da888', fontSize: '1.2rem', fontWeight: 600 }}>
                      {' '}
                      Verified
                    </span>
                    <span> ใช้ข้อมูลจากสำนักบริหารการทะเบียน กรมการปกครอง</span>
                  </>
                }
                style={{ marginBottom: 10 }}
              />
            )}

            <Row>
              <Input
                defaultValue={schema.id}
                name={'id'}
                inputRef={register}
                style={{ display: 'none' }}
              />
              {schema.submission && (
                <Col xs={24} sm={8} md={6} lg={6} style={{ marginTop: '10px' }}>
                  <ControlLabel
                    className={classNames(
                      'style-text-lable',
                      isRequired(schema.submission.validators) && 'required'
                    )}
                  >
                    {schema.submission.label}
                  </ControlLabel>
                  <ErrorMessage error={errors.submission} />
                  <Controller
                    name={schema.submission.name}
                    control={control}
                    defaultValue={schema.submission.value}
                    rules={isValidators(schema.submission.validators)}
                    render={(props) => {
                      return (
                        <SelectPicker
                          data={schema.submission.options}
                          value={props.value}
                          style={{ width: '100%' }}
                          searchable={false}
                          placeholder="เลือก"
                          onChange={(value) => {
                            props.onChange(value)
                            setSubMission(value)
                            if (value == 1 && schema.isKYC) {
                              setValue(schema.idNumber.name, schema.idCardNumber)
                              setIsVerification(false)
                            } else {
                              setIsVerification(true)
                              clearInput()
                            }
                          }}
                        />
                      )
                    }}
                  />
                </Col>
              )}
              <Col xs={24} sm={8} md={6} lg={6} style={{ marginTop: '10px' }}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.idNumber.validators) && 'required'
                  )}
                >
                  {schema.idNumber.label}
                </ControlLabel>
                <ErrorMessage error={errors.idNumber} />
                <InputGroup style={{ width: '100%' }}>
                  <Controller
                    name={schema.idNumber.name}
                    control={control}
                    defaultValue={schema.idNumber.value}
                    rules={isValidators(schema.idNumber.validators)}
                    render={(props) => {
                      return (
                        <Input
                          placeholder={schema.idNumber.label}
                          disabled={subMission == 1 && schema.isKYC}
                          value={props.value}
                          maxLength={getMaxLengthData(schema.idNumber.validators).value}
                          onChange={(value, e) => {
                            if (value) {
                              value = value?.replace(' ', '')
                            }
                            if (isNaN(value)) {
                              return
                            }
                            props.onChange(value)
                          }}
                        />
                      )
                    }}
                  />
                  {subMission == 1 && schema.isKYC && (
                    <Whisper
                      placement="bottom"
                      open={!isVerification}
                      speaker={<Tooltip style={{ fontSize: 15 }}>กรุณาตรวจสอบ</Tooltip>}
                    >
                      <InputGroup.Button
                        onClick={() => onClickVerificationPerson()}
                        disabled={isLoadingVerification}
                      >
                        ตรวจสอบ
                      </InputGroup.Button>
                    </Whisper>
                  )}
                </InputGroup>
                {schema?.passportNumber && (
                  <>
                    <br />
                    <ErrorMessage error={errors[schema.passportNumber.name]} />
                    <ControlLabel>
                      {requiredFiled(schema.passportNumber.validators, schema.passportNumber.label)}
                    </ControlLabel>
                    <Input
                      name={schema.passportNumber.name}
                      defaultValue={schema.passportNumber.value}
                      inputRef={register(isValidators(schema.passportNumber.validators))}
                      disabled={!isVerification}
                    />
                  </>
                )}
              </Col>

              {/* {!schema.thaiDVerified && ( */}
              <Col xs={24} sm={8} md={4} lg={4} style={{ marginTop: '10px' }}>
                <ControlLabel className={classNames('style-text-lable', false)}>
                  {' '}
                  &nbsp;
                </ControlLabel>
                <Button
                  appearance="primary"
                  onClick={onThaiDVerified}
                  disabled={isLoadThaiDVerifing}
                >
                  Verified ผ่าน ThaiD
                </Button>
              </Col>
              {/* )} */}
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col xs={24} sm={8} md={6} lg={6} style={{ marginTop: '10px' }}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.honorific.validators) && 'required'
                  )}
                >
                  {schema.honorific.label}
                </ControlLabel>
                <ErrorMessage error={errors.honorific} />
                <Controller
                  name={schema.honorific.name}
                  control={control}
                  defaultValue={schema.honorific.value}
                  rules={isValidators(schema.honorific.validators)}
                  render={(props) => {
                    return (
                      <SelectPicker
                        data={honorificOptions}
                        value={props.value}
                        style={{ width: '100%' }}
                        placeholder="เลือก"
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                        disabled={!isVerification}
                      />
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={8} md={6} lg={6} style={{ marginTop: '10px' }}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.firstName.validators) && 'required'
                  )}
                >
                  {schema.firstName.label}
                </ControlLabel>
                <ErrorMessage error={errors.firstName} />
                <Input
                  placeholder={schema.firstName.label}
                  defaultValue={schema.firstName.value}
                  name={schema.firstName.name}
                  inputRef={register(isValidators(schema.firstName.validators))}
                  disabled={!isVerification}
                />
              </Col>
              <Col xs={24} sm={8} md={8} lg={8} style={{ marginTop: '10px' }}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.lastName.validators) && 'required'
                  )}
                >
                  {schema.lastName.label}
                </ControlLabel>
                <ErrorMessage error={errors.lastName} />
                <Input
                  placeholder={schema.lastName.label}
                  defaultValue={schema.lastName.value}
                  name={schema.lastName.name}
                  inputRef={register(isValidators(schema.lastName.validators))}
                  disabled={!isVerification}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={8} md={6} lg={6} style={{ marginTop: '10px' }}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.dateOfBirth.validators) && 'required'
                  )}
                >
                  {schema.dateOfBirth.label}
                </ControlLabel>
                <ErrorMessage error={errors.dateOfBirth} />
                <Controller
                  name={schema.dateOfBirth.name}
                  control={control}
                  defaultValue={
                    schema.dateOfBirth.value
                      ? moment(schema.dateOfBirth.value, DATE_FORMAT).toDate()
                      : null
                  }
                  rules={isValidators(schema.dateOfBirth.validators)}
                  render={(props) => {
                    return (
                      <DatePicker
                        format="DD/MM/YYYY"
                        locale={LOCAL_DAY_TH}
                        block
                        placement="auto"
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                        }}
                        disabled={!isVerification}
                      />
                    )
                  }}
                />
              </Col>

              {schema?.placeOfCard && (
                <>
                  <Col xs={24} sm={8} md={6} lg={6} style={{ marginTop: '10px' }}>
                    <ControlLabel
                      className={classNames(
                        'style-text-lable',
                        isRequired(schema.placeOfCard.validators) && 'required'
                      )}
                    >
                      {schema.placeOfCard.label}
                    </ControlLabel>
                    <ErrorMessage error={errors.placeOfCard} />
                    <Input
                      placeholder={schema.placeOfCard.label}
                      defaultValue={schema.placeOfCard.value}
                      name={schema.placeOfCard.name}
                      inputRef={register(isValidators(schema.placeOfCard.validators))}
                      disabled={!isVerification}
                    />
                  </Col>
                </>
              )}

              {schema?.expirationDate && (
                <>
                  <Col xs={24} sm={8} md={8} lg={8} style={{ marginTop: '10px' }}>
                    <ControlLabel
                      className={classNames(
                        'style-text-lable',
                        isRequired(schema.expirationDate.validators) && 'required'
                      )}
                    >
                      {schema.expirationDate.label}
                    </ControlLabel>
                    <ErrorMessage error={errors.expirationDate} />
                    <Controller
                      name={schema.expirationDate.name}
                      control={control}
                      defaultValue={
                        schema.expirationDate.value
                          ? moment(schema.expirationDate.value, DATE_FORMAT).toDate()
                          : null
                      }
                      rules={isValidators(schema.expirationDate.validators)}
                      render={(props) => {
                        return (
                          <DatePicker
                            format="DD/MM/YYYY"
                            locale={LOCAL_DAY_TH}
                            block
                            placement="auto"
                            value={props.value}
                            onChange={(value) => {
                              props.onChange(value)
                            }}
                            disabled={!isVerification}
                          />
                        )
                      }}
                    />
                  </Col>
                </>
              )}
            </Row>
          </FormGroup>


          {schema?.personType && (
            <FormGroup>
            <Row>
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: '10px' }}>
                  <ControlLabel
                    className={classNames(
                      'style-text-lable',
                      isRequired(schema.personType.validators) && 'required'
                    )}
                  >
                    {schema.personType.label}
                  </ControlLabel>
                  <ErrorMessage error={errors.personType} />
                  <Controller
                    name={schema.personType.name}
                    control={control}
                    defaultValue={schema.personType.optionSelected || schema.personType.value}
                    rules={isValidators(schema.personType.validators)}
                    render={(props) => {
                      return (
                        <RadioGroup
                          name="personTypeRadioList"
                          inline
                          value={props.value}
                          onChange={(value) => {
                            props.onChange(value)
                            setSubType(value)
                          }}
                        >
                          {schema.personType?.options &&
                            schema.personType.options.map((item) => (
                              <Radio key={item.value} value={item.value} disabled={!isVerification}>
                                {item.label}
                              </Radio>
                            ))}
                        </RadioGroup>
                      )
                    }}
                  />
                </Col>
            </Row>
          </FormGroup>
          )}
          {granteeType && isEmpty(subType) && offerFundedInfo && offerFundedInfoSchema && (
            <Row>
              <Message
                type="info"
                showIcon
                style={{ marginTop: 5 }}
                description={
                  <>
                    <strong>{offerFundedInfoSchema?.header}</strong>
                    <ul style={{ marginTop: 10 }}>
                      {renderOfferFundedInfo(granteeType, subType)?.map((item, index) => {
                        return <li key={index}>{item}</li>
                      })}
                    </ul>
                  </>
                }
              />
              <br />
            </Row>
            )}

          <FormGroup>
            <Row>
              <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: '10px' }}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.nationality.validators) && 'required'
                  )}
                >
                  {schema.nationality.label}
                </ControlLabel>
                <ErrorMessage error={errors.nationality || errors.nationalityInputOther} />
                <Controller
                  name={schema.nationality.name}
                  control={control}
                  defaultValue={schema.nationality.value}
                  rules={isValidators(schema.nationality.validators)}
                  render={(props) => {
                    return (
                      <RadioGroup
                        name="radioList"
                        inline
                        value={props.value}
                        onChange={(value) => {
                          props.onChange(value)
                          if (value === 2) {
                            setShowOtherNationality(true)
                          } else {
                            setShowOtherNationality(false)
                          }
                        }}
                      >
                        {schema.nationality?.options &&
                          schema.nationality.options.map((item) => (
                            <Radio key={item.value} value={item.value} disabled={!isVerification}>
                              {item.label}
                            </Radio>
                          ))}
                        {/* <Radio value="OTHER">อื่นๆ</Radio> */}
                      </RadioGroup>
                    )
                  }}
                />
              </Col>
              {showOtherNationality && (
                <Col xs={16} sm={16} md={16} lg={16}>
                  <Input
                    name={'nationalityInputOther'}
                    placeholder={schema.nationality.inputOther.label}
                    defaultValue={schema.nationality.inputOther.value}
                    inputRef={register(isValidators(schema.nationality?.inputOther?.validators))}
                    disabled={!isVerification}
                  />
                </Col>
              )}
            </Row>
          </FormGroup>
          <FormGroup>
            <Row>
              <Col xs={24} sm={8} md={8} lg={8} style={{ marginTop: '10px' }}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.telephone.validators) && 'required'
                  )}
                >
                  {schema.telephone.label}
                </ControlLabel>
                <ErrorMessage error={errors.telephone} />
                <Controller
                  name={schema.telephone.name}
                  control={control}
                  defaultValue={schema.telephone.value}
                  rules={isValidators(schema.telephone.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={schema.telephone.label}
                        value={props.value}
                        maxLength={getMaxLengthData(schema.telephone.validators).value}
                        onChange={(value, e) => {
                          if (isNaN(value)) {
                            return
                          }
                          props.onChange(value)
                        }}
                        disabled={!isVerification}
                      />
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={8} md={8} lg={8} style={{ marginTop: '10px' }}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.mobile.validators) && 'required'
                  )}
                >
                  {schema.mobile.label}
                </ControlLabel>
                <ErrorMessage error={errors.mobile} />
                <Controller
                  name={schema.mobile.name}
                  control={control}
                  defaultValue={schema.mobile.value}
                  rules={isValidators(schema.mobile.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={schema.mobile.label}
                        value={props.value}
                        maxLength={getMaxLengthData(schema.mobile.validators).value}
                        onChange={(value, e) => {
                          if (isNaN(value)) {
                            return
                          }
                          props.onChange(value)
                        }}
                        disabled={!isVerification}
                      />
                    )
                  }}
                />
              </Col>
              <Col xs={24} sm={8} md={8} lg={8} style={{ marginTop: '10px' }}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.fax.validators) && 'required'
                  )}
                >
                  {schema.fax.label}
                </ControlLabel>
                <ErrorMessage error={errors.fax} />
                <Controller
                  name={schema.fax.name}
                  control={control}
                  defaultValue={schema.fax.value}
                  rules={isValidators(schema.fax.validators)}
                  render={(props) => {
                    return (
                      <Input
                        placeholder={schema.fax.label}
                        value={props.value}
                        maxLength={getMaxLengthData(schema.fax.validators).value}
                        onChange={(value, e) => {
                          if (isNaN(value)) {
                            return
                          }
                          props.onChange(value)
                        }}
                        disabled={!isVerification}
                      />
                    )
                  }}
                />
              </Col>
            </Row>
            <Row>
              <Col xs={24} sm={8} md={8} lg={8} style={{ marginTop: '10px' }}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.email.validators) && 'required'
                  )}
                >
                  {schema.email.label}
                  <InformationIncon
                    iconColor={'#f17e26'}
                    backgroundColor={'#fff'}
                    color={'#000'}
                    message={
                      "กรณีที่ทำสัญญาอิเล็กทรอนิกส์ ** อีเมลที่ระบุจะต้องเป็นอีเมลเดียวกับที่ลงทะเบียน Web Portal เพื่อเชื่อมโยงไปยังระบบ e-Signature  และต้อง KYC แล้วเท่านั้น"
                    }
                  />
                </ControlLabel>
                <ErrorMessage error={errors.email} />
                <Input
                  placeholder={schema.email.label}
                  defaultValue={schema.email.value}
                  name={schema.email.name}
                  inputRef={register(isValidators(schema.email.validators))}
                  disabled={!isVerification}
                />
              </Col>
              <Col xs={24} sm={8} md={8} lg={8} style={{ marginTop: '10px' }}>
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isRequired(schema.lineId.validators) && 'required'
                  )}
                >
                  {schema.lineId.label}
                </ControlLabel>
                <ErrorMessage error={errors.lineId} />
                <Input
                  placeholder={schema.lineId.label}
                  defaultValue={schema.lineId.value}
                  name={schema.lineId.name}
                  inputRef={register(isValidators(schema.lineId.validators))}
                  disabled={!isVerification}
                />
              </Col>

              {schema?.position && (
                <>
                  <Col xs={24} sm={8} md={8} lg={8} style={{ marginTop: '10px' }}>
                    <ControlLabel
                      className={classNames(
                        'style-text-lable',
                        isRequired(schema.position.validators) && 'required'
                      )}
                    >
                      {schema.position.label}
                    </ControlLabel>
                    <ErrorMessage error={errors.position} />
                    <Input
                      placeholder={schema.position.label}
                      defaultValue={schema.position.value}
                      name={schema.position.name}
                      inputRef={register(isValidators(schema.position.validators))}
                      disabled={!isVerification}
                    />
                  </Col>
                </>
              )}
            </Row>
          </FormGroup>
          {/* <FormGroup>
            <Row style={{ justifyItems: 'center' }}>
              <Col xs={0} sm={0} md={4} lg={4} />
              {subMission === 2 && (
                <>
                  <Col
                    xs={24}
                    sm={12}
                    md={subMission === 0 ? 14 : 8}
                    lg={subMission === 0 ? 14 : 8}
                  >
                    <Controller
                      key={'isDeletePowerOfAttorney'}
                      name={'isDeletePowerOfAttorney'}
                      control={control}
                      defaultValue={isDeletePowerOfAttorney}
                    />
                    <ControlLabel
                      className={classNames(
                        'style-text-lable',
                        isRequired(schema.powerOfAttorney.validators) && 'required'
                      )}
                    >
                      {schema.powerOfAttorney.label}
                    </ControlLabel>
                    <ErrorMessage error={errors.powerOfAttorney} />
                    {powerOfAttorneyFileError && (
                      <Message
                        style={{ marginTop: 10, marginBottom: 10 }}
                        closable
                        onClose={() => {
                          setPowerOfAttorneyFileError(false)
                        }}
                        showIcon
                        type="error"
                        description="อัพโหลดไฟล์รูปภาพหรือ PDF เท่านั้น *** ชนิดไฟล์ที่รองรับ png , jpeg , jpg , pdf ***"
                      />
                    )}
                    <Controller
                      name={'powerOfAttorney'}
                      control={control}
                      defaultValue={undefined}
                      rules={
                        schema.powerOfAttorney.value
                          ? schema.powerOfAttorney.value &&
                            isDeletePowerOfAttorney &&
                            isValidators(schema.powerOfAttorney.validators)
                          : isValidators(schema.powerOfAttorney.validators)
                      }
                      render={(props) => {
                        return (
                          <Uploader
                            disabled={!isVerification}
                            draggable
                            autoUpload={false}
                            listType="picture-text"
                            fileList={props.value || []}
                            onChange={(fileList) => {
                              if (isEmpty(fileList)) {
                                props.onChange(undefined)
                              } else {
                                let file = fileList[fileList.length - 1]
                                if (!file || isImageOrPdf(file.blobFile.type)) {
                                  let files = []
                                  files.push(fileList[fileList.length - 1])
                                  props.onChange(files)
                                  setPowerOfAttorneyFileError(false)

                                  schema.powerOfAttorney.value && setIsDeletePowerOfAttorney(true)
                                } else {
                                  props.onChange(undefined)
                                  setPowerOfAttorneyFileError(true)
                                }
                              }
                            }}
                          >
                            <div>
                              <div className={classNames('uploader', `${theme[0]}-background`)}>
                                <Icon size="4x" icon="upload2" />
                                <small className="uploder__text">
                                  <span style={{ wordBreak: 'break-word' }}>
                                    คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                                  </span>
                                </small>
                              </div>
                            </div>
                          </Uploader>
                        )
                      }}
                    />
                    {schema.powerOfAttorney.value && !isDeletePowerOfAttorney && (
                      <Row style={{ marginTop: 10 }}>
                        <div style={{ width: '100%', textAlign: 'center' }}>
                          <div style={{ marginTop: 10 }}>
                            <ButtonGroup>
                              <IconButton
                                appearance="ghost"
                                icon={
                                  <Icon
                                    appearance="ghost"
                                    icon="eye"
                                    className="bt-gost-icon-radius"
                                  />
                                }
                                onClick={() => {
                                  handleFile(
                                    'view',
                                    schema.powerOfAttorney.value.path,
                                    schema.powerOfAttorney.value.name
                                  )
                                }}
                              >
                                แสดง
                              </IconButton>
                              <IconButton
                                appearance="ghost"
                                icon={
                                  <Icon
                                    appearance="ghost"
                                    icon="download"
                                    className="bt-gost-icon-none-radius"
                                  />
                                }
                                onClick={() => {
                                  handleFile(
                                    'download',
                                    schema.powerOfAttorney.value.path,
                                    schema.powerOfAttorney.value.name
                                  )
                                }}
                              >
                                ดาวน์โหลด
                              </IconButton>
                              <IconButton
                                appearance="ghost"
                                className="rs-btn-ghost-cancel"
                                icon={
                                  <Icon
                                    appearance="ghost"
                                    icon="trash"
                                    className="bt-gost-icon-none-radius-cancel"
                                  />
                                }
                                onClick={() => {
                                  setIsDeletePowerOfAttorney(true)
                                  setValue('isDeletePowerOfAttorney', true)
                                }}
                              >
                                ลบไฟล์
                              </IconButton>
                            </ButtonGroup>
                          </div>
                        </div>
                      </Row>
                    )}
                  </Col>
                </>
              )}

              <Col
                xs={24}
                sm={12}
                md={subMission === 1 || subMission === 0 ? 14 : 8}
                lg={subMission === 1 || subMission === 0 ? 14 : 8}
              >
                <Controller
                  key={'isDeleteIdCard'}
                  name={'isDeleteIdCard'}
                  control={control}
                  defaultValue={isDeleteIdCard}
                />
                <ControlLabel
                  className={classNames(
                    'style-text-lable',
                    isSubProject && isRequired(schema.idCard.validators) && 'required'
                  )}
                >
                  {schema.idCard.label}
                </ControlLabel>
                {idCardFileError && (
                  <Message
                    style={{ marginTop: 10, marginBottom: 10 }}
                    closable
                    onClose={() => {
                      setIdCardFileError(false)
                    }}
                    showIcon
                    type="error"
                    description="อัพโหลดไฟล์รูปภาพหรือ PDF เท่านั้น *** ชนิดไฟล์ที่รองรับ png , jpeg , jpg , pdf ***"
                  />
                )}
                {isSubProject && <ErrorMessage error={errors.idCard} />}
                <Controller
                  name={'idCard'}
                  control={control}
                  defaultValue={undefined}
                  // defaultValue={!isEmpty(schema.idCard.value) ? [schema.idCard.value] : undefined}
                  rules={isSubProject && isValidators(schema.idCard.validators)}
                  render={(props) => {
                    return (
                      <Uploader
                        disabled={!isVerification}
                        draggable
                        autoUpload={false}
                        listType="picture-text"
                        fileList={props.value || []}
                        onChange={(fileList) => {
                          if (isEmpty(fileList)) {
                            props.onChange(undefined)
                          } else {
                            let file = fileList[fileList.length - 1]
                            if (!file || isImageOrPdf(file.blobFile.type)) {
                              let files = []
                              files.push(fileList[fileList.length - 1])
                              props.onChange(files)
                              setIdCardFileError(false)

                              schema.idCard.value && setIsDeleteIdCard(true)
                            } else {
                              props.onChange(undefined)
                              setIdCardFileError(true)
                            }
                          }
                        }}
                      >
                        <div>
                          <div className={classNames('uploader', `${theme[0]}-background`)}>
                            <Icon size="4x" icon="upload2" />
                            <small className="uploder__text">
                              <span style={{ wordBreak: 'break-word' }}>
                                คลิกหรือลากไฟล์มายังพื้นที่นี้เพื่ออัปโหลด
                              </span>
                            </small>
                          </div>
                        </div>
                      </Uploader>
                    )
                  }}
                />

                {schema.idCard.value && !isDeleteIdCard && (
                  <Row style={{ marginTop: 10 }}>
                    <div style={{ width: '100%', textAlign: 'center' }}>
                      <div style={{ marginTop: 10 }}>
                        <ButtonGroup>
                          <IconButton
                            appearance="ghost"
                            icon={
                              <Icon appearance="ghost" icon="eye" className="bt-gost-icon-radius" />
                            }
                            onClick={() => {
                              handleFile('view', schema.idCard.value.path, schema.idCard.value.name)
                            }}
                          >
                            แสดง
                          </IconButton>
                          <IconButton
                            appearance="ghost"
                            icon={
                              <Icon
                                appearance="ghost"
                                icon="download"
                                className="bt-gost-icon-none-radius"
                              />
                            }
                            onClick={() => {
                              handleFile(
                                'download',
                                schema.idCard.value.path,
                                schema.idCard.value.name
                              )
                            }}
                          >
                            ดาวน์โหลด
                          </IconButton>
                          <IconButton
                            appearance="ghost"
                            icon={
                              <Icon
                                appearance="ghost"
                                icon="trash"
                                className="bt-gost-icon-none-radius-cancel"
                              />
                            }
                            onClick={() => {
                              setIsDeleteIdCard(true)
                              setValue('isDeleteIdCard', true)
                            }}
                          >
                            ลบไฟล์
                          </IconButton>
                        </ButtonGroup>
                      </div>
                    </div>
                  </Row>
                )}
              </Col>

              <Col xs={0} sm={0} md={4} lg={4} />
              {fileErr && (
                <Col xs={24} sm={24} md={24} lg={24} style={{ marginTop: 10 }}>
                  <Message
                    showIcon
                    type="error"
                    description={fileErr}
                    closable
                    onClose={() => {
                      setFileErr('')
                    }}
                  />
                </Col>
              )}
            </Row>
          </FormGroup> */}
        </Form>
      </Grid>
    </>
  )
}
